import { create } from "zustand";
import { mtdCancellRto, mtdTracking } from "../api/api";

export const useMtdReport = create((set) => ({
  mtdData: {},
  mtdCancData: {},
  mtdLoading: false,
  mtdCancLoading:false,
  error: null,
  fetchmtdIntervalData: async (currentStartDate, currentEndDate, previousStartDate, previousEndDate) => {
    try {
      set({ mtdLoading: true, error: null });
      const response = await mtdTracking(currentStartDate, currentEndDate, previousStartDate, previousEndDate)
      set({ mtdData: response.data, mtdLoading: false });
    } catch (error) {
      set({ error: error.message, mtdLoading: false });
    }
  },
  fetchmtdIntervalCancRtoData: async (currentStartDate, currentEndDate, previousStartDate, previousEndDate) => {
    try {
      set({ mtdCancLoading: true, error: null });
      const response = await mtdCancellRto(currentStartDate, currentEndDate, previousStartDate, previousEndDate)
      set({ mtdCancData: response.data , mtdCancLoading: false });
    } catch (error) {
      set({ error: error.message, mtdCancLoading: false });
    }
  }
}));